<section class="invite-accept">
  <div class="invite-accept__panel">
    <header class="invite-accept__header">
      <div class="invite-accept__header-icon" aria-hidden="true">
        <img src="/public/svgs/family-together.svg" alt="" width="22" height="22" />
      </div>
      <div class="invite-accept__header-copy">
        <h1 class="invite-accept__title">
          {{ titleKey() | translate }}
        </h1>
        <p
          class="invite-accept__message"
          [class.invite-accept__message--success]="status() === 'success'"
          [class.invite-accept__message--error]="
            status() === 'error' || status() === 'rejected'
          "
        >
          {{ messageKey() | translate }}
        </p>
      </div>
    </header>

    @if (status() === 'loading') {
      <div class="invite-accept__spinner" aria-hidden="true"></div>
    }

    @if (status() === 'need-auth') {
      <div class="invite-accept__actions">
        <app-parent-button variant="primary" (clicked)="goAuth()">
          {{ 'app.familyHub.acceptPage.signIn' | translate }}
        </app-parent-button>
      </div>
    }

    @if (status() === 'ready' && invite(); as inv) {
      <div class="invite-accept__from">
        <span class="invite-accept__avatar" aria-hidden="true">
          {{ inv.invitedByDisplayName | slice: 0 : 1 }}
        </span>
        <p class="invite-accept__from-text">
          {{
            'app.familyHub.acceptPage.from'
              | translate: { name: inv.invitedByDisplayName }
          }}
        </p>
      </div>
      <div class="invite-accept__actions">
        <app-parent-button variant="primary" (clicked)="accept()">
          {{ 'app.familyHub.accept' | translate }}
        </app-parent-button>
        <app-parent-button variant="ghost" (clicked)="reject()">
          {{ 'app.familyHub.reject' | translate }}
        </app-parent-button>
      </div>
    }

    @if (status() === 'success') {
      <div class="invite-accept__actions">
        @if (needsKyc()) {
          <app-parent-button variant="primary" (clicked)="goVerify()">
            {{ 'app.familyHub.acceptPage.continueKyc' | translate }}
          </app-parent-button>
        }
        <a routerLink="/family" class="invite-accept__link">
          {{ 'app.familyHub.acceptPage.goHub' | translate }}
        </a>
      </div>
    }
  </div>
</section>
